import { IMANAGE_API, IMANAGE_CONFIG } from '@/api/drives.constants';
import { baseUrlApis, iManageApi } from '@/api/index';
import { convertController, fileController } from '@/components/viewer/Controllers';
import { getFileNameWithoutExtension, getFileSize, windowActionFn } from '@/utils/utils';
import { store } from '@store/store.index';
import { localToGlobal } from '..';
import qs from 'qs'
import { DRIVE_DLG_TYPE_COMBINE, DRIVE_DLG_TYPE_CONVERT, DRIVE_DLG_TYPE_SAVE_AS } from '@/store/constants';
import intl from 'react-intl-universal';
import { iManage } from '../../../api/drives.constants';

export default class IManageService {
  constructor() {
    this.dialogHandlerDebounce = null
    this.userEmail = null;
    this.unsubscribe = null;
    this.saveAsExtensionType = null;
    this.iManageCloudAuthUrl =
      `https://cloudimanage.com/auth/oauth2/authorize?client_id=b5595267-5cac-4256-867c-5a8a8a13aa70&scope=user&response_type=code&redirect_uri=${baseUrlApis.getBaseUrl()}iManageAuthrizationWin.html`;
  }
  updateSaveAsExtensionType(extension) {
    this.saveAsExtensionType = extension
  }
  getUserEmail() {
    return this.userEmail
  }
  unsubscribeDialogHandler() {
    this.unsubscribe && this.unsubscribe();
    this.unsubscribe = null;
  }
  resetDialogHandlerDebounce() {
    this.dialogHandlerDebounce = null
  }
  dialogHandler() {
    if (this.unsubscribe) {
      return
    }

    const unsubscribe = imanage.dialogs.handler((message) => {
      if (this.dialogHandlerDebounce) {
        clearTimeout(this.dialogHandlerDebounce)
        this.resetDialogHandlerDebounce()
      }

      this.dialogHandlerDebounce = setTimeout(() => {
        this.dialogHandlerDebounce = null

        // process message data
        console.log('Received data from the dialog: ', message.data);
        const { operateType } = store.driveStore
  
        // examine message type
        switch (message.type) {
          case 'unauthorized':
            // redirect partner web app for re-authentication
            break;
          case 'select':
            // user selected an item
            const item = message.data.output_data.selected[0];
            const loc = message.data.output_data.loc
  
            item.libraryName = item.database;
            item.documentId = item.id;
  
            if (operateType === 'open') {
              this.downloadAndOpenFile(item, loc);
              store.docStore.setDocDriveName(iManage);
              return
            }
            if (operateType === 'save') {
              const folderId = message.data.selected
              const libraryName = item.libraryName
              const { doc_profile } = message.data.output_data
              const params = {
                libraryName,
                folderId,
                doc_profile
              }
              const { funType } = store.driveStore
  
              if (funType === DRIVE_DLG_TYPE_SAVE_AS) {
                localToGlobal.doSaveFile(null, null, null, null, libraryName, folderId, doc_profile)
              } else {
                this.uploadDocToFolder(params)
              }
  
              return
            }
            if (operateType === 'add') {
              const items = message.data.output_data.selected
  
              items.forEach((item) => {
                const { size, file_edit_date, id, database } = item
  
                item.documentId = id
                item.libraryName = database
                item.modifiedTime = file_edit_date
                item.size = getFileSize(size)
                item.name = `${item.name}.${item.extension}`
              })
  
              store.driveStore.onAddFilesForAddPanel(items)
  
              return
            }
            
            break;
          case 'cancel':
            if (operateType === 'open') {
              store.appStore.hideOpenFileDlg()
            } else if (operateType === 'save') {
              localToGlobal.onCloseSaveFilePanel()
            } else if (operateType === 'add') {
              const { funType } = store.driveStore
  
              if (funType === DRIVE_DLG_TYPE_COMBINE) {
                store.driveStore.onCloseDrivesDlgForCombineFiles()
              } else if (funType === DRIVE_DLG_TYPE_CONVERT){
                localToGlobal.onCloseIManageDlgForConvertMultiFiles()
              }
            }
            break;
          default:
            console.log('Unsupported message type received: ', message.type);
            break;
        }
      }, 500);
    });

    this.unsubscribe = unsubscribe;
  }
  openLogOutWin() {
    let left = window.innerWidth / 2 - 300;
    let win = windowActionFn(window, 'open', ['https://cloudimanage.com/auth/logout', 'iManageAuthorizationWin', `width=600, height=645, left=${left}, top=240`]);
    
    setTimeout(() => {
      win && win.close()
    }, 3000);
  }
  loginIManage(success, closeWin, /* fail */) {
    let timerFlag = null;
    let left = window.innerWidth / 2 - 300;
    let win = windowActionFn(window, 'open', [this.iManageCloudAuthUrl, 'iManageAuthorizationWin', `width=600, height=645, left=${left}, top=240`]);
    const onSignSuccess = async (code) => {
      try {
        const res = await iManageApi.getAccessToken(code);
  
        if (res.httpCode !== 200) {
          throw 'error'
        }
  
        const data = JSON.parse(res.data);
        const accessToken = data.access_token;
        const refreshToken = data.refresh_token;
  
        iManageApi.setAccessToken(accessToken, refreshToken);
  
        const filePickerUrl = await this.getFilePickerUrl().catch((error) => {
          return error;
        });
  
        if (filePickerUrl) {
          store.userStore.doSendGAEvent({eventKey: 'login_success', label: 'iManage10', category: 'iManage10', action: 'login_success'});
          
          success && success(filePickerUrl);
        }
      } catch (error) {
        console.error(error);
        clean()
      }
    };

    function onHandleWindowMessage(event) {
      let origin = baseUrlApis.getBaseUrl();

      if (event.data.iManageCloudCode && `${event.origin}/` === origin) {
        onSignSuccess(event.data.iManageCloudCode);
      }
    }
    // function onHandleStorage(event) {
    //   if (event.key === 'oneDriveCode') {
    //     onSignSuccess(event.newValue);
    //     clean();
    //   }
    // }
    function clean() {
      if (!win) {
        return;
      }

      win.close();
      win = null;
      closeWin && closeWin()
      timerFlag && clearInterval(timerFlag);
      timerFlag = null;
      window.removeEventListener('message', onHandleWindowMessage);
      // window.removeEventListener('storage', onHandleStorage);
    }
    // start to listen
    timerFlag = setInterval(() => {
      if (!!win && win.closed) {
        clean();
      }
    }, 2000);

    window.addEventListener('message', onHandleWindowMessage, false);
    // window.addEventListener('storage', onHandleStorage, false);
  }
  async getFilePickerUrl() {
    try {
      const { operateType, modalType } = store.driveStore
      const accessToken = iManageApi.retrieveAccessToken();
      const discoverInfoRes = await iManageApi.getDiscoveryInfo(accessToken);
  
      if (discoverInfoRes.httpCode !== 200) {
        return;
      }
  
      let filename
      let filePickerMode
      let typefilters
      let startDoc
      let multiselect = false
      const discoverInfoData = JSON.parse(discoverInfoRes.data);
      const { customer_id: customerId, email } = discoverInfoData.data.user;
      const dialogTokenRes = await iManageApi.getDialogToken(customerId);
      const { funType } = store.driveStore

      this.userEmail = email
      iManageApi.setUserEmail(email)
      iManageApi.setCustomerId(customerId);
  
      if (dialogTokenRes.httpCode !== 200) {
        return;
      }
  
      const { iManageInfo: { item } } = store.driveStore

      if (item) {
        const { documentId } = item

        startDoc = documentId
      }

      if (operateType === 'open') {
        filePickerMode = 'open'
        typefilters =
          "All+Documents@0|WORDX,WORDXT,DOTX,DOTM,DOT,WORDXM,DOCM,WORD,ANSI,RTF,EXCEL,EXCELX,EXCELXT,XLSM,XLSB,XLAM,XLTX,XLTM,XLT,MHT,XLA,XLM,XLW,ODC,ODS,PPTX,PPT,PPTM,PPSX,PPS,PPSM,POTX,POT,POTM,ODP,PPTXT,ACROBAT,WPD$Microsoft+Word+2007+Documents@1|WORDX$Microsoft+Word+Templates@2|WORDXT,DOTX,DOTM,DOT$Microsoft+Word+Macroenabled+Documents@3|WORDXM,DOCM$Microsoft+Word+97-2003+Documents@4|WORD$RTF+Documents@5|RTF$Microsoft+Excel@6|EXCEL,EXCELX,EXCELXT,XLSM,XLSB,XLAM,XLTX,XLTM,XLT,MHT,XLA,XLM,XLW,ODC,ODS$Microsoft+PowerPoint@7|PPTX,PPT,PPTM,PPSX,PPS,PPSM,POTX,POT,POTM,ODP,PPTXT$FoxitPhantom+PDF@8|ACROBAT&dfindex=0"
      }
      if (operateType === 'save') {
        const { fileName } = store.docStore.docInfo;

        filename = getFileNameWithoutExtension(fileName)
        filePickerMode = 'save'

        if (funType !== DRIVE_DLG_TYPE_SAVE_AS) {
          typefilters = 'pdf'
        } else {
          typefilters = this.saveAsExtensionType
        }
      }
      if (operateType === 'add' && modalType === 'convert') {
        filePickerMode = 'open';
        multiselect = true;
        typefilters =
          'Microsoft+Word+2007+Documents@1|WORDX$Microsoft+Word+Templates@2|WORDXT,DOTX,DOTM,DOT$Microsoft+Word+Macroenabled+Documents@3|WORDXM,DOCM$Microsoft+Word+97-2003+Documents@4|WORD$RTF+Documents@5|RTF$Microsoft+Excel@6|EXCEL,EXCELX,EXCELXT,XLSM,XLSB,XLAM,XLTX,XLTM,XLT,MHT,XLA,XLM,XLW,ODC,ODS$Microsoft+PowerPoint@7|PPTX,PPT,PPTM,PPSX,PPS,PPSM,POTX,POT,POTM,ODP,PPTXT';
      }
      if (operateType === 'add' && modalType === 'combine') {
        filePickerMode = 'open';
        multiselect = true;
        typefilters =
          'All+Documents@0|WORDX,WORDXT,DOTX,DOTM,DOT,WORDXM,DOCM,WORD,ANSI,RTF,EXCEL,EXCELX,EXCELXT,XLSM,XLSB,XLAM,XLTX,XLTM,XLT,MHT,XLA,XLM,XLW,ODC,ODS,PPTX,PPT,PPTM,PPSX,PPS,PPSM,POTX,POT,POTM,ODP,PPTXT,ACROBAT,WPD$Microsoft+Word+2007+Documents@1|WORDX$Microsoft+Word+Templates@2|WORDXT,DOTX,DOTM,DOT$Microsoft+Word+Macroenabled+Documents@3|WORDXM,DOCM$Microsoft+Word+97-2003+Documents@4|WORD$RTF+Documents@5|RTF$Microsoft+Excel@6|EXCEL,EXCELX,EXCELXT,XLSM,XLSB,XLAM,XLTX,XLTM,XLT,MHT,XLA,XLM,XLW,ODC,ODS$Microsoft+PowerPoint@7|PPTX,PPT,PPTM,PPSX,PPS,PPSM,POTX,POT,POTM,ODP,PPTXT$FoxitPhantom+PDF@8|ACROBAT&dfindex=0';
      }
      
      let urlParams
      let queryString
      const dialogTokenData = JSON.parse(dialogTokenRes.data);
      const dialogToken = dialogTokenData.data.dialog_token;

      urlParams = {
        protocol: 'postmessage',
        dialogToken,
        customerId,
        mode: filePickerMode,
        multiselect,
        typefilters,
        startdoc: startDoc,
        filename
      }
      queryString = qs.stringify(urlParams)

      // if (operateType === 'save') {
      //   Object.assign(urlParams, {typefilters})
      // }

      const filePickerUrl = `${IMANAGE_API.iManageHost}/work/partner-apps/${IMANAGE_CONFIG.CLIENT_ID}/dialogs/file-picker/?${queryString}`;

      this.dialogHandler();

      return filePickerUrl;
    } catch (error) {
      if (error && error.msg === 'service unavailable') {
        store.appStore.setGlobalMessage({type: 'error', content: intl.get('IManage.getFilePickerUrlError')})
      }
      if (error && error.msg === 'not-authenticated') {
        store.appStore.setGlobalMessage({type: 'error', content: intl.get('IManage.tokenExpired')})
      }
      if (error && error.msg === 'offline') {
        store.appStore.setGlobalMessage({type: 'error', content: intl.get('Error.offline')})
      }

      console.error(error);

      throw error
    }
  }
  openFilePickerInNewWin(filePickerUrl) {
    const width = 980;
    const height = 600;
    const left = (window.innerWidth - 980) / 2;
    const top = Math.floor((window.innerHeight - 600) / 2);

    windowActionFn(window, 'open', [filePickerUrl, 'iManageAuthorizationWin', `width=${width}, height=${height}, left=${left}, top=${top}`]);
  }

  isSignIn() {
    const accessToken = iManageApi.retrieveAccessToken();

    if (accessToken) {
      return true;
    }
  }
  async updateFile(callback) {
    try {
      const fileBuffer = await fileController.getCurrentDocBuffer()
      const fileBlob = new Blob(fileBuffer[0])
      const { iManageInfo: { libraryName, documentId, profile } } = store.driveStore
      const params = {
        libraryName,
        documentId,
        profile,
        file: fileBlob,
      }
      const res = await iManageApi.updateFile(params)
  
      callback && callback()

      if (res.httpCode === 201) {
        store.appStore.doUpdateDocModified(false)
        store.appStore.setGlobalMessage({type: 'success', content: intl.get('UploadingFile.success')})
        store.docStore.setDocDriveName(iManage);
      } else {
        throw 'update file failed'
      }
    } catch (error) {
      store.appStore.setGlobalMessage({type: 'error', content: intl.get('UploadingFile.fail')})
      callback && callback()
      
      console.error(error);
    }
  }
  async uploadDocToFolder(params) {
    try {
      store.driveStore.onNumberOfAjaxCAllPendingIncrease()

      const fileBuffer = await fileController.getCurrentDocBuffer()
      const fileBlob = new Blob(fileBuffer[0])
  
      Object.assign(params, {file: fileBlob})
  
      const res = await iManageApi.createFile(params)

      if (res.httpCode === 201) {
        store.driveStore.onResetAjaxCAllPending()
        store.appStore.doUpdateDocModified(false)
        store.appStore.setGlobalMessage({type: 'success', content: intl.get('UploadingFile.success')})
        store.docStore.setDocDriveName(iManage);
      } else {
        throw 'upload file failed'
      }
    } catch (error) {
      store.appStore.setGlobalMessage({type: 'error', content: intl.get('UploadingFile.fail')})

      console.error(error);
    }

    localToGlobal.onCloseSaveFilePanel()
  }
  async downloadAndOpenFile(item, loc) {
    const {
      extension,
      documentId,
      libraryName,
      access,
      comment,
      database,
      default_security,
      name,
      type,
      type_description,
      wstype,
      warnings_for_required_and_disabled_fields,
    } = item;

    store.driveStore.onNumberOfAjaxCAllPendingIncrease()

    try {
      const res = await iManageApi.downloadFile(item);
      const fileName = `${name}.${extension}`;
      const profile = {
        profile: {
          doc_profile: {
            access,
            comment,
            database,
            default_security,
            name,
            // size,
            type,
            type_description,
            wstype,
          },
          warnings_for_required_and_disabled_fields,
        },
      };
  
      if (extension === 'pdf') {
        await window.pdfui.openPDFByFile(res, { fileName });
  
        store.driveStore.resetNumberOfAjaxCAllPending()
        store.driveStore.updateIManageInfo({isFromIManage: true, documentId, libraryName, profile, isSaveBackToIManage: true, loc, item})
        store.appStore.hideOpenFileDlg();
      } else {
        convertController.doConvertToPDF(
          new File([res], fileName),
          (result) => {
            if (result && result != 'stop' && result.ret == 0 && result.url) {
              if (!store.viewer.hasOpenFile || !store.appStore.docModified) {
                const { url, fileName } = result;
  
                fileController.doOpenFileByUrl(
                  url,
                  fileName,
                  (/* err */) => {},
                  null,
                  () => {
                    store.driveStore.resetNumberOfAjaxCAllPending()
                    store.driveStore.updateIManageInfo({isFromIManage: true, documentId, libraryName, profile, isSaveBackToIManage: false, loc, item})
                  },
                );
                return;
              }
              // this.onShowToDoDlg(result);
            }
          },
          (/*err*/) => {},
          true,
        );
        store.appStore.hideOpenFileDlg();
      }
    } catch (error) {
      store.driveStore.resetNumberOfAjaxCAllPending()

      console.error(error);
    }
  }
  loginOut = async (success) => {
    try {
      const res = await iManageApi.revokeAccessToken()
      // const logoutRes = await iManageApi.loginOut();

      this.openLogOutWin()
      success && success(res)
    } catch (error) {
      
    }
  }
}
